// Two looks: "new" is the redesign, "classic" is the site as it was before.
// A visitor's choice is kept in a cookie; without one, the site's default
// applies (RAZZLE_DEFAULT_LOOK, set per deployment, see devops/staging).
export const LOOK_COOKIE = 'asaj_look';
export const LOOK_MAX_AGE_S = 60 * 60 * 24 * 365;
export const LOOKS = ['new', 'classic'];

export const isLook = (value) => LOOKS.includes(value);

// The visitor's cookie wins, then the site default, then the new look
export function resolveLook(chosen, siteDefault) {
  if (isLook(chosen)) return chosen;
  return isLook(siteDefault) ? siteDefault : 'new';
}

export const otherLook = (look) => (look === 'classic' ? 'new' : 'classic');

// The switch is a plain link: the server sets the cookie and sends the
// visitor back to the same page (see express-middleware/lookSwitch.js)
export function switchHref(pathname, look) {
  return `${pathname || '/'}?look=${look}`;
}

export const LOOK_NAMES = { classic: 'classic look', new: 'new look' };
